//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as axios from "@/store/http";
import * as auth from "@/utils/auth";

    export default {
        name: "ChangeSys",
      data(){
          return{
            options: [
              {
                value: "CONTRACT",
                label: this.$t('login.contact')
              },
              {
                value: "SCM",
                label: this.$t('login.scm')
              },
              {
                value: "PROJECT",
                label: this.$t('login.project')
              },
              {
                value: "HR",
                label: this.$t('login.hr')
              }
            ],
            value: '',//语言选择下拉框当前语言文字描述
          }
      },
      methods:{
         headChangeLang(value){
            //根据业务来调整到指定的系统主页
            if(value === 'CONTRACT'){
              window.location.href = process.env.SYS_LINK_CONTRACT+"layout/home";
            }
            if(value === 'SCM'){
              window.location.href = process.env.SYS_LINK_SCM+"layout/home";
            }
            if(value === 'PROJECT'){
              window.location.href = process.env.SYS_LINK_PROJECT+"layout/home";
            }
            if(value === 'HR'){
              window.location.href = process.env.SYS_LINK_HR+"layout/home";
            }
        },
      },
      mounted(){
        var sysid = process.env.SYS_NAME;
        // 初始化语言下拉框描述文字
        for(var i=0; i<this.options.length; i++){
          if(this.options[i].value === sysid){
            this.value = this.options[i].label
            break
          }
        }
      }
    }



// WEBPACK FOOTER //
// ./src/pccomponents/ChangeSys.vue